import React from "react";
import "./BoardsDetailDisclaimer.css";

const DISCLAIMER_BODY =
  "This datasheet is based on current manufacturing knowledge and laboratory testing. Declared values are nominal and may vary within normal production tolerances. The manufacturer is not liable for failures resulting from improper storage, handling, installation, modification, or use outside intended service conditions.";

const BoardsDetailDisclaimer = () => {
  return (
    <aside className="boardsDetailDisclaimer" aria-label="Disclaimer">
      <div className="boardsDetailDisclaimer-inner">
        <div className="boardsDetailDisclaimer-iconWrap" aria-hidden="true">
          <div className="boardsDetailDisclaimer-diamond">
          </div>
        </div>
        <div className="boardsDetailDisclaimer-text">
          <h2 className="boardsDetailDisclaimer-title">Disclaimer</h2>
          <p className="boardsDetailDisclaimer-body">{DISCLAIMER_BODY}</p>
        </div>
      </div>
    </aside>
  );
};

export default BoardsDetailDisclaimer;
